import type { FormDefinition } from '@gov-design-system-ce/react-form-core';
import type { ContactDetailsFormData } from '@gov-nx/core/hooks';
import { getDefaultPhoneValue } from '@gov-nx/utils/common';

export const setContactDetailsValues = <T extends ContactDetailsFormData>(
	form: FormDefinition<T>,
	{ email, _useEmail, _usePhone, phone }: ContactDetailsFormData
): void => {
	const { formMethods } =
		form as unknown as FormDefinition<ContactDetailsFormData>;

	formMethods.setValue('_useEmail', _useEmail);
	formMethods.setValue('email', email ?? '');

	formMethods.setValue('_usePhone', _usePhone);
	formMethods.setValue('phone', phone ?? getDefaultPhoneValue());
};
